import { Injectable } from '@angular/core';
import { Client } from '@microsoft/microsoft-graph-client';
import { AuthService } from './auth.service';
import { AlertsService } from './alerts.service';

@Injectable()
export class GraphService {
    private graphClient: Client;

    constructor(private authService: AuthService, private alertsService: AlertsService) {
        // Initialize the Graph client
        this.graphClient = Client.init({
            authProvider: async (done) => {
                // Get the token from the auth service
                let token = await this.authService.getAccessToken()
                    .catch((reason) => {
                        done(reason, null);
                    });

                if (token) {
                    done(null, token);
                } else {
                    done("Could not get an access token", null);
                }
            }
        });
    }

    async createGroup(name: string, owners: string[], members: string[]): Promise<any> {
        try {
            var body = {
                'displayName': name,
                'description': name,
                'mailEnabled': true,
                'mailNickname': name,
                'securityEnabled': false,
                'owners@odata.bind': owners,
                'members@odata.bind': members,
                'groupTypes': ['Unified']
            };

            let result = await this.graphClient.api('/groups').post(body);

            return result.value;
        } catch (error) {
            alert(error);
        }
    }

    async createTeam(name: string, owners: string[], members: string[]): Promise<any> {
        try {
            var body = {
                'displayName': name,
                'description': name,
                'mailEnabled': true,
                'mailNickname': name,
                'securityEnabled': false,
                'owners@odata.bind': owners,
                'members@odata.bind': members,
                'groupTypes': ['Unified']
            };

            let result = await this.graphClient.api('/groups').post(body);

            if (result.value != null) {
                var test = {
                    'memberSettings': {}
                };
                let teamResult = await this.graphClient.api('/groups/' + result.value.id + '/team').put(test);
            }

            return result.value;
        } catch (error) {
            alert('error');
        }
    }

    async getGroups(): Promise<any> {
        try {
            let result = await this.graphClient.api('/groups').get();

            return result.value;
        } catch (error) {
            alert('error');
        }
    }

    async getTeams(): Promise<any> {
        try {
            let result = await this.graphClient.api('/groups').select(['id', 'displayName', 'resourceProvisioningOptions']).get();

            return result.value;
        } catch (error) {
            alert('error');
        }
    }

    async getUsers(): Promise<any> {
        try {
            let result = await this.graphClient.api('/users').select(['id','mail']).get();
        } catch (error) {
            alert('error');
        }
    }

    async getGroupByName(teamName: string): Promise<any> {
        try {
            let result = await this.graphClient.api('/groups').filter("startswith(displayName, '" + teamName + "')").get();

            return result.value;
        } catch (error) {
            alert('error');
        }
    }

    async getUserTeams(): Promise<any> {
        try {
            let result = await this.graphClient.api('/me/joinedTeams').get();

            return result.value;
        } catch (error) {
            alert('error');
        }
    }

    async sendMessage(): Promise<any> {
        try {
            let result = await this.graphClient.api('https://graph.microsoft.com/beta/teams/4f80fc4d-db8f-4083-b863-27a045f6596c/channels/19:2b1c1037e2cc476192db669e2e6da17d@thread.skype/chatThreads')
                .post({
                    "rootMessage": {
                        "body": {
                            "contentType": 2,
                            "content": "<a>Testing</a>"
                        }
                    }
                });

            return result.value;
        } catch (error) {
            alert('error');
        }
    }
}

export interface CreateGroupBody {
    displayName: string;
    description: string;
    mailEnabled: boolean;
    mailNickname: string;
    securityEnabled: boolean;
    groupTypes: string[];
    owners: string[];
    members: string[];
}